<template>
  <div class="page-header">
    <div class="page-header__top">
      <div class="page-header__titles">
        <h1 class="page-header__title">{{ title }}</h1>
        <p v-if="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.actions" class="page-header__actions">
        <slot name="actions" />
      </div>
    </div>
    <template v-if="$slots.filters">
      <button
        type="button"
        class="page-header__filters-toggle"
        @click="showFilters = !showFilters"
      >
        {{ showFilters ? 'Hide filters' : 'Filters' }}
      </button>
      <div class="page-header__filters" :class="{ 'is-open': showFilters }">
        <slot name="filters" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
  data() {
    return {
      // dipakai cuma di mobile buat sembunyiin filters slot, lihat CSS
      showFilters: false,
    };
  },
};
</script>

<style scoped>
.page-header {
  padding-top: var(--mz-space-5);
  margin-bottom: var(--mz-space-4);
}

.page-header__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--mz-space-3);
}

.page-header__title {
  margin: 0;
  font-size: var(--mz-fs-xl);
  font-weight: var(--mz-fw-title);
  color: var(--mz-text-strong);
}

.page-header__subtitle {
  margin: var(--mz-space-1) 0 0;
  font-size: var(--mz-fs-sm);
  color: var(--mz-text-muted);
}

.page-header__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--mz-space-2);
}

.page-header__filters {
  margin-top: var(--mz-space-3);
}

.page-header__filters-toggle {
  display: none;
}

/* ≤768px: aksi turun ke bawah judul, filters disembunyikan di balik tombol toggle */
@media (max-width: 768px) {
  .page-header {
    padding-top: var(--mz-space-4);
  }

  .page-header__top {
    flex-wrap: wrap;
  }

  .page-header__actions {
    width: 100%;
  }

  .page-header__filters-toggle {
    display: inline-flex;
    align-items: center;
    margin-top: var(--mz-space-2);
    padding: var(--mz-space-1) var(--mz-space-3);
    border: 1px solid var(--mz-border-strong);
    border-radius: var(--mz-radius-pill);
    background: var(--mz-surface);
    color: var(--mz-text);
    font-size: var(--mz-fs-sm);
    font-weight: var(--mz-fw-label);
  }

  .page-header__filters {
    display: none;
  }

  .page-header__filters.is-open {
    display: block;
  }
}
</style>
